/** API of the workshops referential (port of WorkshopService). */
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';
import type { WithId } from '@/shared/api/types';

export const workshopRecordSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  fullAddress: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
});

export type WorkshopRecord = z.infer<typeof workshopRecordSchema>;

export const workshopRecordsQueryOptions = () =>
  queryOptions({
    queryKey: ['workshops'] as const,
    queryFn: () =>
      api.get<WorkshopRecord[]>('workshop', {
        schema: z.array(workshopRecordSchema),
      }),
    retry: false,
  });

/** Payload of the create / update calls: the fields of the dialog. */
export interface WorkshopInput {
  name: string;
  fullAddress: string;
  email: string;
  phone: string;
}

export const createWorkshop = (data: WorkshopInput) =>
  api.post<unknown>('workshop', data);

export const updateWorkshop = (data: WithId<WorkshopInput>) =>
  api.put<unknown>('workshop', data);
